import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './public.scss'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'quill/dist/quill.snow.css'
import './libs/prototypeTools'
import Print from 'vue-print-nb'

Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.use(Print)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
